import type { CameraApiResponse } from "@src/services/api/cameras-api";
import { formatCameraLabel, getCameraDisplayName, getCameraKeyString, getSiteString } from "@src/utils/key-parser";

export type CameraFilterField = "All" | "Camera ID" | "Name" | "Site";

export function filterCamerasByQuery(
  cameras: CameraApiResponse[],
  query: string,
  field?: CameraFilterField,
): CameraApiResponse[] {
  const normalized = query.toLowerCase().trim();
  if (!normalized) return cameras;

  return cameras.filter((camera) => {
    const rawKey = getCameraKeyString(camera);
    const cameraKey = rawKey.toLowerCase();
    // The label an unnamed camera's card shows ("CAM_11143 - Camera A"), so a
    // search for what's on screen matches; the raw id is "camera-a".
    const label = formatCameraLabel(rawKey).toLowerCase();
    const site = getSiteString(camera).toLowerCase();
    const displayName = (camera.name || getCameraDisplayName(cameraKey))?.toLowerCase() ?? "";
    const nickname = camera.nickname?.toLowerCase() ?? "";
    const name = camera.name?.toLowerCase() ?? "";

    switch (field) {
      case "Camera ID":
        return cameraKey.includes(normalized);
      case "Name":
        return (
          displayName.includes(normalized) ||
          label.includes(normalized) ||
          nickname.includes(normalized) ||
          name.includes(normalized)
        );
      case "Site":
        return site.includes(normalized);
      default:
        return (
          cameraKey.includes(normalized) ||
          site.includes(normalized) ||
          displayName.includes(normalized) ||
          label.includes(normalized) ||
          nickname.includes(normalized) ||
          name.includes(normalized)
        );
    }
  });
}
